import type { IanaTimezoneName } from "api/generated/model";

import { useOrgUserProfileCookie } from "./profileCookie";

export const DEFAULT_TIMEZONE = "Europe/Copenhagen";
export function useCurrentUserTimezone(): IanaTimezoneName {
    const orgProfileCookie = useOrgUserProfileCookie();
    return orgProfileCookie?.timezone || DEFAULT_TIMEZONE;
}
